import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';
import MainNavigation from 'components/Credit24/SelfService/Navigation/MainNavigation';
import SectionTitle from 'components/Credit24/SelfService/Navigation/SectionTitle';
import { navigationItemsAU, navigationItemsAUIL, navigationItemsFI } from 'consts/selfservice/navigationItems';

export default (WrappedComponent, TitleSection, layout = 'DEFAULT') => {
  const createTitle = () => {
    if (isString(TitleSection)) {
      return (
        <SectionTitle titleKey={TitleSection} />
      );
    }

    if (isObject(TitleSection)) {
      return <TitleSection />;
    }

    return null;
  };

  class PrivateRouteContainer extends Component {
    constructor(props) {
      super(props);
      this.redirectTo = this.redirectTo.bind(this);
      this.redirectToLogin = this.redirectToLogin.bind(this);
      this.redirectToIncompleteStatus = this.redirectToIncompleteStatus.bind(this);
      this.redirectToMigrationScreen = this.redirectToMigrationScreen.bind(this);
    }

    UNSAFE_componentWillMount() {
      const { authentication } = this.props;
      if (!authentication.isAuthenticated) {
        this.redirectToLogin();
      } else {
        if (COUNTRY === 'AU') {
          if (
            authentication.identificationState
            && authentication.identificationState === 'NOT_STARTED_YET'
          ) {
            this.redirectToMigrationScreen();
            return;
          }
        }
        if (authentication.contracts && authentication.contracts.length === 0) {
          this.redirectToIncompleteStatus();
        }
      }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.authentication.isAuthenticated && !nextProps.authentication.isAuthenticated) {
        this.redirectToLogin();
      } else {
        if (COUNTRY === 'AU') {
          if (
            !this.props.authentication.identificationState
            && nextProps.authentication.identificationState
            && nextProps.authentication.identificationState === 'NOT_STARTED_YET'
          ) {
            this.redirectToMigrationScreen();
            return;
          }
        }
        if (
          !this.props.authentication.contracts
          && nextProps.authentication.contracts
          && nextProps.authentication.contracts.length === 0
        ) {
          this.redirectToIncompleteStatus();
        }
      }
    }

    redirectTo(pathname, checkPath) {
      const { router: { location, replace } } = this.props;
      if (checkPath && location.pathname === pathname) {
        return;
      }
      replace({ pathname, search: location.search, state: { from: location } });
    }

    redirectToLogin() {
      this.redirectTo('/login');
    }

    redirectToIncompleteStatus() {
      this.redirectTo('/status', true);
    }

    redirectToMigrationScreen() {
      this.redirectTo('/welcome', true);
    }

    render() {
      const { authentication, selfservice } = this.props;
      const contractId = authentication.contracts && authentication.contracts[0];
      const contract = selfservice.contracts[contractId];
      let isProductLoadedAU = true;
      if (COUNTRY === 'AU') {
        isProductLoadedAU = !!(contract && contract.product);
      }

      if (!authentication.isAuthenticated) {
        return (
          <div />
        );
      }

      if (layout === 'CUSTOM') {
        return <WrappedComponent />;
      }

      let navigationItems;

      if (COUNTRY === 'FI') {
        navigationItems = navigationItemsFI;
      }
      if (COUNTRY === 'AU') {
        navigationItems = navigationItemsAU;

        if (contract && contract.product && contract.product.type === 'INSTALLMENT') {
          navigationItems = navigationItemsAUIL;
        }
      }

      const title = createTitle();

      if (layout === 'WHOLE') {
        return (
          <>
            <div className="container">
              {isProductLoadedAU && title}
            </div>
            <main className="container container--mobile-fullWidth">
              <WrappedComponent />
            </main>
          </>
        );
      }

      return (
        <>
          <div className="container">
            {isProductLoadedAU && title}
          </div>
          <div className="container container--mobile-fullWidth">
            <div className="grid">
              <main className="grid__item three-quarters portable-one-whole">
                <WrappedComponent />
              </main>
              <aside className="page-sidebar grid__item one-quarter portable-one-whole hide-portable">
                {isProductLoadedAU
                  && <MainNavigation navigationItems={navigationItems} />}
              </aside>
            </div>
          </div>
        </>
      );
    }
  }

  PrivateRouteContainer.propTypes = {
    authentication: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    selfservice: PropTypes.object.isRequired,
  };

  return withRouter(connect(
    (state) => ({
      authentication: state.authentication,
      selfservice: state.selfservice,
    })
  )(PrivateRouteContainer));
};
